export default "__VITE_ASSET__9WpCgWlf__"